import { queryOptions } from '@tanstack/react-query'
import { getEventGroupsFromRoot, getGroupHighlights } from '../api/groups'
import { sportsOfferingQueryKeys } from './keys'
import { getKambiBetOffersByIds } from '../api/betOffers'
import { getEventsBySportTermKey, getUpcomingEventsForAllSports } from '../api/events'
import { getEventsForLeague, getFuturesEventsForCompetition } from '../api/listView'

export const getEventGroupsFromRootQuery = queryOptions({
  queryFn: getEventGroupsFromRoot,
  queryKey: sportsOfferingQueryKeys.EventGroupsFromRoot,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getMatchesBySportTermKeyQuery = (sport: string) =>
  queryOptions({
    queryFn: () => getEventsBySportTermKey(sport),
    queryKey: sportsOfferingQueryKeys.EventsForSport(sport),
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })

export const getGroupHighlightsQuery = queryOptions({
  queryFn: getGroupHighlights,
  queryKey: sportsOfferingQueryKeys.EventGroupHighlights,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getUpcomingEventsForAllSportsQuery = queryOptions({
  queryFn: getUpcomingEventsForAllSports,
  queryKey: sportsOfferingQueryKeys.UpcomingEventsForAllSports,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getBetOffersByIds = (betOfferIds: number[]) =>
  queryOptions({
    queryKey: [sportsOfferingQueryKeys.BetOffersByIds, betOfferIds],
    queryFn: () => getKambiBetOffersByIds({ betOfferIds }),
    staleTime: 1_000 * 60 * 10, // 10min
  })

export const getMatchesForCompetition = (sport: string, region: string, league: string) =>
  queryOptions({
    queryFn: () => getEventsForLeague(sport, region, league, 'all'),
    queryKey: [sportsOfferingQueryKeys.EventsForCompetition(sport, region, league), 'matches'],
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })

export const getFuturesForCompetition = (sport: string, region: string, league: string) =>
  queryOptions({
    queryFn: () => getFuturesEventsForCompetition(sport, region, league),
    queryKey: [sportsOfferingQueryKeys.EventsForCompetition(sport, region, league), 'futures'],
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })
